import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from '../constants';
import { MatchingPropertyService } from '../matching-property/matching-property.service';

@Component({
  selector: 'pioneer-pagination-sort',
  templateUrl: './pagination-sort.component.html'
})
export class PaginationSortComponent implements OnInit {

  @Input()
  label: string;

  @Input()
  field: string;

  isSorted: boolean;

  isAsc: boolean;

  @Output()
  public sortPage: EventEmitter< {field: string, direction: string} > = new EventEmitter< {field: string, direction: string} >();

  constructor(
    private matchingPropertyService: MatchingPropertyService,
  ) { }

  ngOnInit() {
    this.matchingPropertyService.selectedField$.subscribe(field => {
      if (field && field === this.field) {
        this.isSorted = true;
      } else {
        this.resetSort();
      }
    });
  }

  resetSort() {
    this.isSorted = false;
    this.isAsc = false;
  }

  sortList() {
    this.isSorted = true;
    this.isAsc = !this.isAsc;
    if (this.isAsc) {
      this.sortPage.emit( { field: this.field, direction: 'asc' } );
    } else {
      this.sortPage.emit( { field: this.field, direction: 'desc' } );
    }
    this.matchingPropertyService.setSelectedField(this.field);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pagination-sort/pagination-sort.component.ts